/**
 * Hook de actividad de una tarea (log de eventos sistémicos: cambios de estado,
 * asignaciones, etc.). El timeline del detalle nuevo (PR-T5) va a mezclar este
 * feed con el de comentarios y notas.
 */
import { useQuery } from '@tanstack/react-query';

import * as activityApi from '../api/taskActivity';
import { TASK_KEYS } from './keys';

export function useTaskActivity(taskId: string) {
  return useQuery({
    queryKey: TASK_KEYS.activity(taskId),
    queryFn: () => activityApi.listActivity(taskId),
    enabled: !!taskId,
    staleTime: 15_000,
  });
}
